<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'app'
  }
</script>

<style lang="less">
  html{
    background-color: #F5F8FA;
    width: 100%;
  }
  body{
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  }
  a, div, p{
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
  /* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
*/

  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  .loading-text{
    padding: 5px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .text{
      font-size: 14px;
      color: #333;
      margin-left: 10px;
    }
  }
  .all-loaded{
    font-size: 14px;
    color: #666;
    text-align: center;
    padding: 10px 0;
  }
  a{
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
  .delay-fee-info {
    padding-right: 1em;
    padding-top: 1em;
    font-size: 12px;
    line-height: 1.5em;
    display: flex;
    .delay-fee-info-main {
      flex: 1;
    }
    .price {
      color: red;
    }
  }

  .renew-btn {
    box-sizing: border-box;
    border-radius: 3px;
    padding: 5px 12px;
    font-size: 14px;
    height: 30px;
    background-color: #E43779;
    color: #fff;
    border: none;
    &:disabled {
      opacity: 0.6;
    }
  }
</style>



// WEBPACK FOOTER //
// App.vue?7ecd984a